module.exports = __webpack_public_path__ + "static/media/m42.3257bc21.webp";